import React, { useMemo } from 'react';
import { apiHolder, apis, tabType } from 'api';
import ImgPreview from '@web-common/components/UI/ImagePreview/index';
import IconCard from '@web-common/components/UI/IconCard';
import { safeDecodeAttFileName } from '@web-common/utils/xssUtils';
const imgTypes = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'svg', 'SVG', 'gif', 'GIF'];
const systemApi = apiHolder.api.getSystemApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
import { useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
import { useState2SubordinateSlice } from '@web-mail/hooks/useState2SliceRedux';
import { reportAttachPreview } from '@web-mail/utils/mailAttach';
export const ATTACHMENT_KEYS = [
    '_account',
    'downloadContentId',
    'downloadId',
    'fileName',
    'filePreviewUrl',
    'fileType',
    'fileUrl',
    'id',
    'flag',
    'mailId',
    'type',
    'fileSize',
    'attType',
];
const openImgAttachment = (attachment, fileSourceKey) => {
    const onList = attachment
        .filter(i => i.fileType && imgTypes.includes(i.fileType))
        .map(i => (Object.assign(Object.assign({}, i), { nonOriginal: true, downloadUrl: i.fileUrl, previewUrl: i.filePreviewUrl, name: i.fileName, size: i.fileSize })));
    const imgIndex = onList.findIndex(i => i.fileSourceKey === fileSourceKey);
    ImgPreview.preview({ data: onList, startIndex: imgIndex });
};
const cloudPreview = (data, file, _account) => {
    var _a;
    reportAttachPreview({
        filename: (file === null || file === void 0 ? void 0 : file.fileName) || '',
        mid: ((_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.id) || '',
        _account,
    });
    const { attachment, id } = data.entry || {};
    const type = file === null || file === void 0 ? void 0 : file.fileType;
    if (type && imgTypes.includes(type) && attachment) {
        openImgAttachment(attachment, file === null || file === void 0 ? void 0 : file.fileSourceKey);
        return;
    }
    if (systemApi.isElectron() && window.electronLib) {
        systemApi.createWindowWithInitData('resources', {
            eventName: 'initPage',
            eventData: {
                downloadContentId: id,
                downloadId: file === null || file === void 0 ? void 0 : file.downloadId,
                filePreviewUrl: file === null || file === void 0 ? void 0 : file.filePreviewUrl,
                attachments: [Object.assign(Object.assign({}, file), { downloadContentId: data === null || data === void 0 ? void 0 : data.id })],
                fileName: file === null || file === void 0 ? void 0 : file.fileName,
                type: 'attachment',
                hash: `https://resources/#type=attachment&mid=${file === null || file === void 0 ? void 0 : file.contentId}&fileName=${file === null || file === void 0 ? void 0 : file.fileName}&size=${file === null || file === void 0 ? void 0 : file.fileSize}&downloadId=${file === null || file === void 0 ? void 0 : file.downloadId}&downloadContentId=${data === null || data === void 0 ? void 0 : data.id}`,
            },
        });
    }
    else {
        const downloadInfo = Object.assign(Object.assign({}, file), { downloadContentId: data === null || data === void 0 ? void 0 : data.id });
        if (_account) {
            downloadInfo.account = accountApi.getEmailIdByEmail(_account);
        }
        const searchStrArr = ATTACHMENT_KEYS.map(k => `${k}=${encodeURIComponent((downloadInfo && downloadInfo[k]) || '')}`);
        let searchStr = searchStrArr.join('&');
        window.open(`${systemApi.getContextPath()}/attachment/?outDownloadContentId=${encodeURIComponent(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId)}&${searchStr}`);
    }
};
const sortAttachmentsBySearchKey = (items, shouldFilter, searchKey) => {
    if (!shouldFilter || !searchKey)
        return items;
    const hasItems = [];
    const unhasItems = [];
    if (items && items.length) {
        items.forEach(item => {
            if (item.fileName.includes(searchKey)) {
                hasItems.push(item);
            }
            else {
                unhasItems.push(item);
            }
        });
        return hasItems.concat(unhasItems);
    }
    return items;
};
const escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
const highLightStrBySearchKey = (str, isSearching, searckKey) => {
    if (!str || !isSearching || !searckKey)
        return str;
    if (str.includes('<b>' + searckKey + '</b>'))
        return str;
    return str.replaceAll(escapeRegExp(searckKey), '<b>' + searckKey + '</b>');
};
export const defaultComAttachment = (props) => {
    const { data } = props;
    const isSearching = useAppSelector(state => !!state.mailReducer.mailSearching);
    const mailSearchKey = useAppSelector(state => state.mailReducer.mailSearchKey);
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const [mailSearchState_sd] = useState2SubordinateSlice('mailSearchState');
    const [mailSearchKey_sd] = useState2SubordinateSlice('mailSearchKey');
    const [searchTypeSd] = useState2SubordinateSlice('mailSearchType');
    const [advanceSearchFromValues] = useState2SubordinateSlice('more_advanceSearchFromValues');
    const isSearchingSd = useMemo(() => !!mailSearchState_sd, [mailSearchState_sd]);
    const mailSearchKeySd = useMemo(() => {
        let key = '';
        if (mailSearchState_sd === 'more_advanced' && Array.isArray(advanceSearchFromValues.attachments) && advanceSearchFromValues.attachments.some(Boolean)) {
            key = advanceSearchFromValues.attachments.find(Boolean);
        }
        else if (mailSearchState_sd === 'more_server' || mailSearchState_sd === 'server') {
            if (searchTypeSd === 'all' || searchTypeSd === 'attachment') {
                key = mailSearchKey_sd;
            }
        }
        return key;
    }, [mailSearchState_sd, advanceSearchFromValues, mailSearchKey_sd]);
    const isSearching_total = useMemo(() => (currentTabType === tabType.subordinate ? isSearchingSd : isSearching), [isSearching, isSearchingSd, currentTabType]);
    const mailSearchKey_total = useMemo(() => (currentTabType === tabType.subordinate ? mailSearchKeySd : mailSearchKey), [mailSearchKey, mailSearchKeySd, currentTabType]);
    const shouldFilterAttachment = !!(isSearching_total && mailSearchKey_total);
    const { isThread, isTpMail, isEncryptedMail, isDecrypted, _account } = data || {};
    const { attachment } = data.entry || {};
    const filteAttachments = attachment === null || attachment === void 0 ? void 0 : attachment.filter(item => !item.inlined && item.fileType !== 'ics' && item.type !== 'netfolder');
    const attachmentList = sortAttachmentsBySearchKey(filteAttachments || [], shouldFilterAttachment, mailSearchKey_total);
    const unDecrypted = isEncryptedMail && !isDecrypted;
    return (React.createElement(React.Fragment, null, attachmentList === null || attachmentList === void 0 ? void 0 :
        attachmentList.map((_item, index) => {
            const type = unDecrypted ? 'other' : _item.fileType || 'other';
            const fileName = highLightStrBySearchKey(_item.fileName, isSearching_total, mailSearchKey_total);
            if (index < 2) {
                return (React.createElement("div", { key: index, className: "attachment", style: { width: attachmentList.length < 2 ? '' : '50%' }, onClick: e => {
                        if (!isThread && !isTpMail && unDecrypted) {
                            e.stopPropagation();
                            e.preventDefault();
                            cloudPreview(data, _item, _account);
                        }
                    } },
                    React.createElement("div", { className: "attachment-logo" },
                        React.createElement(IconCard, { type: type })),
                    React.createElement("div", { className: "attachment-name" },
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: safeDecodeAttFileName(fileName || _item.fileName || getIn18Text('WEIMINGMING')) } }))));
            }
            return '';
        }),
        attachmentList && attachmentList.length > 2 ? React.createElement("div", { className: "attachment-num" }, `+${attachmentList.length - 2}`) : ''));
};
export const defaultComAttachmentLong = (props) => {
    const { data } = props;
    const { isThread, _account } = data || {};
    const { attachment } = data.entry || {};
    const isSearching = useAppSelector(state => !!state.mailReducer.mailSearching);
    const mailSearchKey = useAppSelector(state => state.mailReducer.mailSearchKey);
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const [mailSearchState_sd] = useState2SubordinateSlice('mailSearchState');
    const [mailSearchKey_sd] = useState2SubordinateSlice('mailSearchKey');
    const [advanceSearchFromValues] = useState2SubordinateSlice('more_advanceSearchFromValues');
    const isSearchingSd = useMemo(() => !!mailSearchState_sd, [mailSearchState_sd]);
    const mailSearchKeySd = useMemo(() => {
        let key = '';
        if (mailSearchState_sd === 'more_advanced' && Array.isArray(advanceSearchFromValues.attachments) && advanceSearchFromValues.attachments.some(Boolean)) {
            key = advanceSearchFromValues.attachments.find(Boolean);
        }
        else if (mailSearchState_sd === 'more_server' || mailSearchState_sd === 'server') {
            key = mailSearchKey_sd;
        }
        return key;
    }, [mailSearchState_sd, advanceSearchFromValues, mailSearchKey_sd]);
    const isSearching_total = useMemo(() => (currentTabType === tabType.subordinate ? isSearchingSd : isSearching), [isSearching, isSearchingSd, currentTabType]);
    const mailSearchKey_total = useMemo(() => (currentTabType === tabType.subordinate ? mailSearchKeySd : mailSearchKey), [mailSearchKey, mailSearchKeySd, currentTabType]);
    const shouldFilterAttachment = !!(isSearching_total && mailSearchKey_total);
    const filterAttachment = attachment === null || attachment === void 0 ? void 0 : attachment.filter(item => !item.inlined && item.fileType !== 'ics' && item.type !== 'netfolder');
    const attachmentList = sortAttachmentsBySearchKey(filterAttachment || [], shouldFilterAttachment, mailSearchKey_total);
    const wrapDoms = document.getElementsByClassName('long-attachments-warp');
    const clientWidth = wrapDoms && wrapDoms.length && wrapDoms[0].clientWidth;
    const itemWidth = 134;
    let needShowNum = (attachmentList === null || attachmentList === void 0 ? void 0 : attachmentList.length) || 0;
    let canShowNum = Math.floor(clientWidth / itemWidth);
    if (needShowNum <= canShowNum) {
        return (React.createElement(React.Fragment, null, attachmentList === null || attachmentList === void 0 ? void 0 : attachmentList.map((_item, index) => {
            const type = _item.fileType || 'other';
            const fileName = highLightStrBySearchKey(_item.fileName, isSearching_total, mailSearchKey_total);
            return (React.createElement("div", { className: "attachment", style: { width: 126, marginRight: 8 }, key: index, onClick: e => {
                    if (!isThread) {
                        e.stopPropagation();
                        e.preventDefault();
                        cloudPreview(data, _item, _account);
                    }
                } },
                React.createElement("div", { className: "attachment-logo" },
                    React.createElement(IconCard, { type: type })),
                React.createElement("div", { className: "attachment-name" },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: safeDecodeAttFileName(fileName || _item.fileName || getIn18Text('WEIMINGMING')) } }))));
        })));
    }
    else {
        return (React.createElement(React.Fragment, null, attachmentList === null || attachmentList === void 0 ? void 0 :
            attachmentList.map((_item, index) => {
                const type = _item.fileType || 'other';
                if (index < canShowNum || (canShowNum === 0 && index === 0)) {
                    return (React.createElement("div", { key: index, className: "attachment", style: { width: 126, marginRight: 8 }, onClick: e => {
                            if (!isThread) {
                                e.stopPropagation();
                                e.preventDefault();
                                cloudPreview(data, _item, _account);
                            }
                        } },
                        React.createElement("div", { className: "attachment-logo" },
                            React.createElement(IconCard, { type: type })),
                        React.createElement("div", { className: "attachment-name" },
                            React.createElement("span", { dangerouslySetInnerHTML: { __html: safeDecodeAttFileName(_item.fileName || getIn18Text('WEIMINGMING')) } }))));
                }
                else {
                    return '';
                }
            }),
            clientWidth != 0 ? React.createElement("div", { className: "attachment-num" }, `+${needShowNum - canShowNum}`) : React.createElement(React.Fragment, null)));
    }
};
